import * as React from 'react';
import type { ILanguage } from '@/types';
import { useTranslation } from 'react-i18next';
import { languages } from '@/config';

const getLang = (id: string): ILanguage => languages.find((l) => l.id === id) ?? languages[0];

export const useLanguageSelector = (): {
  changeLanguage: React.Dispatch<string>;
  language: ILanguage;
  languages: ILanguage[];
} => {
  const { i18n } = useTranslation();
  const [selected, setSelectedLng] = React.useState<ILanguage>(getLang(i18n.language));

  const changeLanguage = (id: string): void => {
    const language = getLang(id);

    i18n
      .changeLanguage(language.id)
      .then(() => setSelectedLng(language))
      .catch((error) => console.log(error));
  };

  return { languages, language: selected, changeLanguage };
};
